<template>
  <v-row>
    <v-col cols="12">
      <v-card elevation="2" v-if="!this.$apollo.loading">
        <v-card-title>Coaching Assessment</v-card-title>
        <v-simple-table>
          <thead>
            <td></td>
            <td>Booked date</td>
            <td>Completed date</td>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Last Check-in</strong>
                <template v-if="userCheckIns.length > 0 && userCheckIns[0].node.assessmentDate">
                  <br />
                  {{ `Completed ${$moment().diff($moment(userCheckIns[0].node.assessmentDate), "days")} days ago` }}
                </template>
              </td>
              <template v-if="userCheckIns.length > 0">
                <td>{{ userCheckIns[0].node.requiredDate | moment("YYYY-MM-DD hh:mm") }}</td>
                <td>
                  {{ userCheckIns[0].node.assessmentDate | moment("YYYY-MM-DD") }}
                </td>
              </template>

              <td v-else>No check-in</td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-card-text>
          <span class="black--text"><strong>Check-in Booking Link:</strong></span>
          <a :href="assessmentURL" target="_blank" class="pl-2 ">{{ assessmentURL }}</a>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="showAssessmentModal">Create new Assessment</v-btn>
          <v-spacer />
          <v-btn :href="viewAllAssessmentsLink">View all check-ins</v-btn>
        </v-card-actions>
        <v-dialog v-model="modals.assessmentModal" width="900">
          <new-assessment :close="closeAssessmentModal" :userId="userId"></new-assessment>
        </v-dialog>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { LAST_ASSESSMENT_WITH_COACH_QUERY } from "@/graphql/queries/assessment";
import NewAssessment from "@/components/dashboard/components/NewAssessment";
import { decodeId } from "@/lib/string";

export default {
  name: "ManageAssessmentBlock",
  props: ["userId"],
  components: {
    NewAssessment,
  },
  data() {
    return {
      modals: {
        assessmentModal: false,
      },
      userCheckIns: null,
      coach: null,
    };
  },
  computed: {
    viewAllAssessmentsLink() {
      if (this.coach) return `/client-profile/${decodeId(this.coach.id)}/${this.userId}/assessments`;
      else return "";
    },
    assessmentURL() {
      if (!this.coach) {
        return null;
      }
      let encoded_json_payload = btoa(
        JSON.stringify({
          userId: this.userId,
        })
      );

      return this.coach.userProfile.assessmentBookingLink + "?salesforce_uuid=" + encoded_json_payload;
    },
  },
  methods: {
    formatDate(date) {
      return YYYYMMDD_readable(date);
    },
    showAssessmentModal() {
      this.modals.assessmentModal = true;
    },
    closeAssessmentModal() {
      this.modals.assessmentModal = false;
    },
  },
  apollo: {
    userCheckIns: {
      query: LAST_ASSESSMENT_WITH_COACH_QUERY,
      variables() {
        return {
          encodedUserId: btoa("UserNode:" + this.userId),
          userId: this.userId,
          orderBy: "-createdAt",
        };
      },
      update(data) {
        this.coach = data.activeSubscription?.coach;
        return data.userCheckIns.edges;
      },
    },
  },
};
</script>
